module.exports = __webpack_public_path__ + "img/swingVariabilityText12.255aa248.png";